import React, { useState } from "react";
import axios from "axios";
import CryptoJS from "crypto-js";
import { BASE_URL } from "../config";
import { useNavigate } from "react-router-dom";
import bgImage from "../Assets/land.jpeg";

const Register = () => {
  const [form, setForm] = useState({
    fullname: "",
    username: "",
    password: "",
    province: "",
    city_municipality: "",
    role: "Farmer",
  });

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const navigate = useNavigate();

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);
    setMessage("");
    setError("");

    const payload = {
      fullname: form.fullname.trim(),
      username: form.username.trim(),
      password: CryptoJS.MD5(form.password).toString(),
      role: form.role.toLowerCase(), // ✅ IMPORTANT
      province: form.province.trim(),
      city_municipality: form.city_municipality.trim(),
    };

    console.log("Sending:", payload);

    try {
      const res = await axios.post(`${BASE_URL}/lisa_users/add`, payload);

      console.log("Success:", res.data);

      setMessage("Account created successfully!");

      setForm({
        fullname: "",
        username: "",
        password: "",
        province: "",
        city_municipality: "",
        role: "Farmer",
      });

      setTimeout(() => navigate("/"), 1500);

    } catch (err) {
      console.log("Error:", err.response);

      if (err.response?.status === 409) {
        setError("Username already exists");
      } else {
        setError(err.response?.data?.message || "Server error");
      }
    }

    setLoading(false);
  };

  return (
    <div style={pageStyle}>
      <div style={overlayStyle}></div>

      <div style={cardStyle}>
        <h2 style={titleStyle}>Sign Up</h2>

        {message && <p style={successStyle}>{message}</p>}
        {error && <p style={errorStyle}>{error}</p>}

        <form onSubmit={handleSubmit}>
          <input name="fullname" placeholder="Full Name" value={form.fullname} onChange={handleChange} required style={inputStyle}/>
          <input name="username" placeholder="Username" value={form.username} onChange={handleChange} required style={inputStyle}/>
          <input type="password" name="password" placeholder="Password" value={form.password} onChange={handleChange} required style={inputStyle}/>

          <select name="role" value={form.role} onChange={handleChange} style={inputStyle}>
            <option value="Farmer">Farmer</option>
            <option value="Administrator">Administrator</option>
          </select>

          <input name="province" placeholder="Province" value={form.province} onChange={handleChange} required style={inputStyle}/>
          <input name="city_municipality" placeholder="City / Municipality" value={form.city_municipality} onChange={handleChange} required style={inputStyle}/>

          <button type="submit" disabled={loading} style={buttonStyle}>
            {loading ? "Creating..." : "Create Account"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Register;
const pageStyle = {
  minHeight: "100vh",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  backgroundImage: `url(${bgImage})`,
  backgroundSize: "cover",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
  position: "relative",
  padding: "20px",
};

const overlayStyle = {
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  background: "rgba(0,0,0,0.55)",
  zIndex: 0,
};

const cardStyle = {
  width: "100%",
  maxWidth: "420px",
  padding: "30px",
  borderRadius: "18px",
  background: "rgba(255, 255, 255, 0.08)",
  backdropFilter: "blur(12px)",
  boxShadow: "0 10px 30px rgba(0,0,0,0.3)",
  color: "#fff",
  position: "relative",
  zIndex: 1,
};

const titleStyle = {
  textAlign: "center",
  marginBottom: "20px",
  fontWeight: "bold",
};

const inputStyle = {
  width: "100%",
  padding: "12px",
  margin: "8px 0",
  borderRadius: "10px",
  border: "none",
  outline: "none",
  fontSize: "14px",
};

const buttonStyle = {
  width: "100%",
  padding: "12px",
  marginTop: "15px",
  borderRadius: "999px",
  border: "none",
  backgroundColor: "rgb(52, 142, 56)",
  color: "white",
  fontWeight: "bold",
  cursor: "pointer",
};

const successStyle = {
  color: "#7CFC00",
  textAlign: "center",
};

const errorStyle = {
  color: "#ff6b6b",
  textAlign: "center",
};